import { PosApiRequest } from "../pos-api-request";

export class SendKeyRequest extends PosApiRequest {
  constructor(input: { Key: string }) {
    super();
    this.Key = input.Key;
  }

  public SessionId?: string;

  public Key: string;

  public Data?: string;
}
